import React from "react";
import { Link } from "react-router-dom";
import "./Nav.css";

function Nav() {
  return (
    <header>
      <nav className="navbar navbar-expand-lg nav-bg" aria-label="Primary navigation">
        <Link className="nav-brand special" to="/" aria-label="Return to Once Upon an Adventure home">
          Once Upon an Adventure
        </Link>
      </nav>
    </header>
  );
}

export default Nav;
